export default {
  path: '/store-search',
  meta: {
    title: '联盟商家查询',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/store-search`),
}



// WEBPACK FOOTER //
// ./src/views/StoreSearch/router.js